import { makeAutoObservable, reaction } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class MenuSegmentsStore {
  private inactiveIds = new Set<number>()

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    reaction(
      () => this._entities.segmentsStore.items,
      () => {
        this.inactiveIds.forEach((id) => {
          if (!this._entities.segmentsStore.hasItem(id)) this.inactiveIds.delete(id)
        })
      }
    )
  }

  get items() {
    return this._entities.segmentsStore.items.filter((item) => !this.isHidden(item.id))
  }

  showItem = (id: number) => {
    this.inactiveIds.delete(id)
  }

  hideItem = (id: number) => {
    this.inactiveIds.add(id)
  }

  isHidden = (id: number) => {
    return this.inactiveIds.has(id)
  }
}
